module.exports = __webpack_public_path__ + "img/s-migaj-Yui5vfKHuzs-unsplash.4d04c7d8.jpg";